// Leapifyes OS - Constants and Configuration

import { ASSETS } from './assets';

export const BRAND = {
  name: 'Leapifyes',
  tagline: 'Con Leapifyes no das un paso, das un salto',
  location: 'Barcelona, España',
  email: 'info@leapifyes.com',
  phone: '+34 694 214 849',
  zohoFormUrl: 'https://forms.zohopublic.eu/leapifyes1/form/HablemosdetuProyecto/formperma/9N9jayyElu2gzPbN-0dZaj-YH7jdRJ0YdxYsA2IwiG4',
  whatsapp: 'https://wa.me/34694214849',
};

export const VALUES = [
  { id: 1, title: 'Acompañamos, no imponemos', description: 'Plan claro, sesiones 1:1 y adopción guiada.' },
  { id: 2, title: 'Das un salto, no un paso', description: 'Quick wins desde la primera semana.' },
  { id: 3, title: 'Lo humano primero', description: 'Herramientas al servicio de tu equipo, no al revés.' },
  { id: 4, title: 'Hablamos claro', description: 'Sin jerga técnica. Con ejemplos reales de tu sector.' },
  { id: 5, title: 'Digital con corazón', description: 'Cercanía, ética y resultados medibles.' },
  { id: 6, title: 'Transformación es necesidad', description: 'La competitividad digital no espera.' },
];

export const SOLUTIONS = [
  {
    id: 'transformacion-digital',
    title: 'Transformación Digital',
    tagline: 'Moderniza tu negocio sin perder tu esencia',
    description: 'Digitalizamos tus procesos con enfoque humano. Automatización inteligente, flujos optimizados y sistemas que trabajan para ti.',
    features: [
      'Auditoría de procesos, datos y herramientas',
      'Mapa de prioridades y quick wins 30/60/90 días',
      'Automatización de procesos repetitivos',
      'Digitalización de documentación',
      'Integración de sistemas existentes',
      'Formación y acompañamiento continuo',
    ],
    icon: 'RefreshCw',
    color: 'from-[#1B93A4]/20 to-[#3B82F6]/20',
    accentColor: '#1B93A4',
    benefits: [
      { title: 'Digitalización de Procesos', description: 'Convertimos tus flujos de trabajo manuales en procesos digitales eficientes y medibles.' },
      { title: 'Automatización Inteligente', description: 'Identificamos tareas repetitivas y las automatizamos para liberar tiempo de tu equipo.' },
      { title: 'Integración de Sistemas', description: 'Conectamos tus herramientas actuales para que trabajen juntas sin duplicar esfuerzos.' },
      { title: 'Análisis y Métricas', description: 'Dashboards claros para tomar decisiones basadas en datos, no en intuición.' },
    ],
    process: [
      { step: '01', title: 'Auditoría de Procesos', description: 'Mapeamos tu operación actual para identificar cuellos de botella y oportunidades.' },
      { step: '02', title: 'Diseño de Solución', description: 'Creamos un plan a medida con prioridades claras y ROI estimado.' },
      { step: '03', title: 'Implementación Gradual', description: 'Desplegamos por fases para minimizar disrupciones y maximizar adopción.' },
      { step: '04', title: 'Formación y Soporte', description: 'Capacitamos a tu equipo y te acompañamos hasta que todo funcione perfecto.' },
    ],
    stats: [
      { value: '-60%', label: 'Tiempo en tareas administrativas' },
      { value: '+40%', label: 'Productividad del equipo' },
      { value: '-75%', label: 'Errores en procesos' },
      { value: '3-6', label: 'Meses para ROI positivo' },
    ],
  },
  {
    id: 'agentes-ia',
    title: 'Agentes IA y Automatización',
    tagline: 'Asistentes inteligentes que trabajan 24/7',
    description: 'Agentes conversacionales que atienden, cualifican y convierten. Desde WhatsApp hasta tu CRM, sin intervención manual.',
    features: [
      'Agente de llamadas IA (atiende aunque estés ocupado)',
      'Generador de presupuestos IA (en segundos)',
      'Asistente WhatsApp IA (atiende, agenda y gestiona)',
      'Atención automatizada multicanal',
      'Cualificación inteligente de oportunidades',
      'Seguimiento y recordatorios automatizados',
    ],
    icon: 'Bot',
    color: 'from-[#D946EF]/20 to-[#3B82F6]/20',
    accentColor: '#D946EF',
    benefits: [
      { title: 'Atención Multicanal', description: 'WhatsApp, web, email. Un solo agente que responde en todos tus canales 24/7.' },
      { title: 'Presupuestos Automáticos', description: 'Genera propuestas personalizadas basadas en las respuestas del cliente.' },
      { title: 'Agendamiento Inteligente', description: 'Coordina citas y visitas sin intervención manual, sincronizado con tu calendario.' },
      { title: 'Seguimiento Proactivo', description: 'Recordatorios, nurturing y follow-ups automáticos que no olvidan ningún lead.' },
    ],
    process: [
      { step: '01', title: 'Análisis de Necesidades', description: 'Identificamos los flujos de atención que más impacto tienen en tu negocio.' },
      { step: '02', title: 'Diseño del Agente', description: 'Configuramos el agente con tu tono de voz, conocimiento de negocio y flujos específicos.' },
      { step: '03', title: 'Integración y Testing', description: 'Conectamos con tus canales (WhatsApp, web, CRM) y hacemos pruebas exhaustivas.' },
      { step: '04', title: 'Lanzamiento y Optimización', description: 'Activamos el agente y optimizamos continuamente según las conversaciones reales.' },
    ],
    stats: [
      { value: '24/7', label: 'Disponibilidad total' },
      { value: '<30s', label: 'Tiempo de respuesta' },
      { value: '+65%', label: 'Conversión de leads' },
      { value: '-80%', label: 'Carga operativa' },
    ],
  },
  {
    id: 'desarrollo-web',
    title: 'Desarrollo Web a Medida',
    tagline: 'Tu web, tu identidad, tu motor de ventas',
    description: 'Diseñamos y desarrollamos webs profesionales, landing pages y aplicaciones web que convierten visitantes en clientes.',
    features: [
      'Diseño UX/UI personalizado y memorable',
      'Desarrollo React / Next.js / FastAPI',
      'SEO técnico y SEO local desde el día 1',
      'Integración con CRM y herramientas de negocio',
      'Performance, velocidad y Core Web Vitals',
      'Responsive total — perfecto en todos los dispositivos',
    ],
    icon: 'Globe',
    color: 'from-[#3B82F6]/20 to-[#1B93A4]/20',
    accentColor: '#3B82F6',
    benefits: [
      { title: 'Diseño a Medida', description: 'Cada web es única. Diseñamos según tu marca, tu sector y tus objetivos de conversión.' },
      { title: 'SEO desde el Día 1', description: 'Arquitectura optimizada para buscadores. Posicionamiento orgánico que crece con el tiempo.' },
      { title: 'Velocidad y Rendimiento', description: 'Core Web Vitals optimizados. Cada milisegundo cuenta para la conversión.' },
      { title: 'Integración Total', description: 'Conectamos tu web con CRM, analytics, chat y todas las herramientas que necesitas.' },
    ],
    process: [
      { step: '01', title: 'Briefing y Estrategia', description: 'Definimos objetivos, público y estructura. Wireframes y mapa de contenidos.' },
      { step: '02', title: 'Diseño UX/UI', description: 'Prototipos visuales con tu identidad de marca. Iteramos hasta que sea perfecto.' },
      { step: '03', title: 'Desarrollo y SEO', description: 'Código limpio, responsive, rápido. SEO técnico y on-page desde el primer commit.' },
      { step: '04', title: 'Lanzamiento y Soporte', description: 'Deploy, testing y formación. Mantenimiento y mejoras continuas.' },
    ],
    stats: [
      { value: '+85%', label: 'Tasa de conversión media' },
      { value: '<2s', label: 'Tiempo de carga' },
      { value: 'Top 10', label: 'Posicionamiento SEO local' },
      { value: '100%', label: 'Responsive garantizado' },
    ],
  },
  {
    id: 'erp-crm',
    title: 'ERP y CRM a Medida',
    tagline: 'Tu negocio tiene procesos únicos. Tu sistema también debería.',
    description: 'Implementamos y desarrollamos sistemas de gestión adaptados exactamente a tu sector y forma de trabajar.',
    features: [
      'Implementación Zoho CRM / Salesforce / Microsoft 365',
      'Desarrollo ERP personalizado (como MANDO)',
      'Pipeline de ventas y seguimiento de clientes',
      'Presupuestos, facturas y control financiero',
      'Paneles de control e indicadores clave (KPIs)',
      'Formación y adopción del equipo',
    ],
    icon: 'Database',
    color: 'from-[#1B93A4]/20 to-[#3B82F6]/20',
    accentColor: '#1B93A4',
    benefits: [
      { title: 'CRM Personalizado', description: 'Pipeline de ventas, seguimiento de leads y gestión de clientes adaptada a tu proceso.' },
      { title: 'ERP Sectorial', description: 'Sistemas de gestión integral diseñados para tu sector específico.' },
      { title: 'Control Financiero', description: 'Presupuestos, facturas, cobros y gastos en un solo panel con visibilidad total.' },
      { title: 'KPIs en Tiempo Real', description: 'Dashboards con los indicadores que importan. Decisiones basadas en datos.' },
    ],
    process: [
      { step: '01', title: 'Auditoría de Procesos', description: 'Mapeamos tu flujo comercial y operativo para diseñar el sistema ideal.' },
      { step: '02', title: 'Selección y Diseño', description: 'Elegimos la plataforma correcta y diseñamos los flujos a medida.' },
      { step: '03', title: 'Configuración e Integración', description: 'Implementamos, migramos datos y conectamos con tus herramientas existentes.' },
      { step: '04', title: 'Formación y Adopción', description: 'Tu equipo domina el sistema desde el día 1. Soporte continuo incluido.' },
    ],
    stats: [
      { value: '+50%', label: 'Visibilidad del pipeline' },
      { value: '-40%', label: 'Tiempo en gestión' },
      { value: '+30%', label: 'Tasa de cierre' },
      { value: '1 panel', label: 'Todo centralizado' },
    ],
  },
  {
    id: 'sistemas-medida',
    title: 'Software y Apps a Medida',
    tagline: 'Tu idea, convertida en software real — web, móvil y en producción',
    description: 'Convertimos tu idea en software real: apps nativas iOS y Android, plataformas SaaS y sistemas internos. Del backend y las integraciones hasta el deployment y la publicación en App Store y Google Play.',
    features: [
      'Apps nativas iOS y Android (React + Capacitor)',
      'Publicación en App Store y Google Play',
      'Plataformas SaaS y marketplaces escalables',
      'Backend, APIs e integraciones (FastAPI, MongoDB)',
      'Deployment y CI/CD — siempre en producción (Railway + Vercel)',
      'Mantenimiento y evolución continua del producto',
    ],
    icon: 'Code',
    color: 'from-[#3B82F6]/20 to-[#D946EF]/20',
    accentColor: '#3B82F6',
    benefits: [
      { title: 'Apps Nativas en Tiendas', description: 'Construimos y publicamos apps nativas iOS y Android con React + Capacitor. AppMando, nuestra app, ya está en el App Store.' },
      { title: 'Desarrollo Full-Stack', description: 'Producto completo: frontend, backend (FastAPI, MongoDB) e integraciones. Escalable desde el día 1.' },
      { title: 'Integraciones API', description: 'Conectamos cualquier sistema con APIs REST, webhooks, pagos (Stripe) y mapas (Mapbox).' },
      { title: 'SaaS Propios', description: 'Diseñamos y lanzamos plataformas SaaS completas. Como MANDO y TRÉBOL.' },
    ],
    process: [
      { step: '01', title: 'Definición de Requisitos', description: 'Entendemos el problema, definimos el alcance y diseñamos la arquitectura.' },
      { step: '02', title: 'Prototipo y Validación', description: 'MVP funcional para validar la solución antes de invertir en desarrollo completo.' },
      { step: '03', title: 'Desarrollo Iterativo', description: 'Sprints de 2 semanas con demos y feedback. Siempre alineados contigo.' },
      { step: '04', title: 'Deploy y Publicación', description: 'En producción con CI/CD, y publicación en App Store / Google Play. Soporte continuo.' },
    ],
    stats: [
      { value: '2 SaaS', label: 'Propios en producción' },
      { value: 'Ciclo completo', label: 'Del concepto al App Store' },
      { value: 'App Store', label: 'App nativa publicada' },
      { value: '24/7', label: 'Stack en producción, operado a diario' },
    ],
    caseStudy: {
      label: 'Caso real · De la idea a la tienda',
      title: 'AppMando no era el encargo de un cliente. Era nuestra propia apuesta.',
      description: 'Quisimos demostrarnos algo: que una idea de servicio puede convertirse en una app nativa, real, viva en el móvil de cualquiera. Así nació AppMando — el marketplace que conecta a particulares con profesionales verificados de reformas y hogar en toda España. No la encargamos fuera. La pensamos, la diseñamos, la construimos y la publicamos nosotros. Hoy está en el App Store y la operamos cada día. Lo que aprendimos levantándola, lo ponemos al servicio de tu proyecto.',
      challenge: 'Un marketplace de verdad no es una pantalla bonita: son dos mundos que tienen que encajar. Verificar profesionales para que el cliente confíe. Un chat que responda al instante. Mapas para saber quién está cerca. Notificaciones que lleguen al móvil en el momento justo. Y, al final del camino, el filtro más exigente de todos: la revisión de Apple para entrar al App Store.',
      stack: ['React 19', 'Capacitor', 'FastAPI', 'MongoDB', 'Railway', 'Vercel'],
      milestone: 'Aprobada por Apple y publicada en el App Store',
      ctaLabel: 'Conoce AppMando',
      ctaHref: '/productos/appmando',
    },
  },
  {
    id: 'cumplimiento-rgpd',
    title: 'Cumplimiento RGPD sin Dolor',
    tagline: 'Cumple la normativa sin parar tu negocio',
    description: 'RGPD, e-factura, Verifactu y protección de datos ordenada, clara y sin tecnicismos jurídicos que te abrumen.',
    features: [
      'Diagnóstico completo de cumplimiento RGPD / LOPD',
      'Implementación e-factura y Verifactu',
      'Documentación, contratos y políticas de privacidad',
      'Banner de cookies y gestión del consentimiento',
      'Formación al equipo en protección de datos',
      'Seguimiento y auditoría continua',
    ],
    icon: 'Shield',
    color: 'from-[#10b981]/20 to-[#1B93A4]/20',
    accentColor: '#10b981',
    benefits: [
      { title: 'Diagnóstico RGPD', description: 'Evaluación completa de tu situación actual frente a la normativa vigente.' },
      { title: 'e-Factura y Verifactu', description: 'Implementación completa del sistema de facturación electrónica obligatorio.' },
      { title: 'Documentación Legal', description: 'Contratos, políticas de privacidad y protocolos de protección de datos.' },
      { title: 'Auditoría Continua', description: 'Seguimiento y actualización constante para mantener el cumplimiento.' },
    ],
    process: [
      { step: '01', title: 'Diagnóstico de Cumplimiento', description: 'Evaluamos tu nivel actual de cumplimiento normativo y detectamos gaps.' },
      { step: '02', title: 'Plan de Acción', description: 'Priorizamos las acciones necesarias por urgencia e impacto.' },
      { step: '03', title: 'Implementación', description: 'Documentación, sistemas y procesos para cumplir la normativa.' },
      { step: '04', title: 'Mantenimiento', description: 'Auditorías periódicas y actualización ante cambios normativos.' },
    ],
    stats: [
      { value: '0', label: 'Sanciones para nuestros clientes' },
      { value: '100%', label: 'Cumplimiento garantizado' },
      { value: '<2 sem', label: 'Implementación básica' },
      { value: 'Continuo', label: 'Seguimiento incluido' },
    ],
  },
];

export const SECTORS = [
  {
    id: 'reformas',
    title: 'Reformas y Construcción',
    subtitle: 'MANDO nació aquí. ERP propio disponible.',
    description: 'Digitalizamos la gestión de reformas: presupuestos, obras, facturas, incidencias y equipo. MANDO es nuestro ERP propio nacido en este sector.',
    icon: 'Building2',
    challenges: [
      'Gestión manual de presupuestos y citas',
      'Pérdida de oportunidades por respuesta lenta',
      'Seguimiento inconsistente de obras y proyectos',
      'Facturación y cobros desorganizados',
    ],
    benefits: [
      'Presupuestos automáticos con MANDO',
      'Agente IA que responde 24/7',
      'Panel de control de obras en tiempo real',
      'Facturación integrada y sin retrasos',
    ],
    stats: [
      { value: '+3', label: 'Obras/mes de media' },
      { value: '-80%', label: 'Tiempo de respuesta' },
      { value: '24/7', label: 'Atención automatizada' },
    ],
  },
  {
    id: 'clinicas',
    title: 'Clínicas y Salud',
    subtitle: 'Gestión de citas, recordatorios y cumplimiento.',
    description: 'Optimizamos la gestión de citas, recordatorios y comunicación con pacientes. Reducimos no-shows y mejoramos la experiencia desde el primer contacto.',
    icon: 'Stethoscope',
    challenges: [
      'No-shows y citas perdidas que cuestan dinero',
      'Comunicación manual con pacientes',
      'Gestión de historiales fragmentada',
      'Tiempo administrativo excesivo del equipo',
    ],
    benefits: [
      'Recordatorios automáticos multicanal',
      'Asistente IA para consultas frecuentes',
      'Gestión centralizada de pacientes',
      'Reducción drástica de tiempo administrativo',
    ],
    stats: [
      { value: '-22%', label: 'Reducción de no-shows' },
      { value: '+4.8', label: 'Rating Google' },
      { value: '12h/sem', label: 'Tiempo ahorrado' },
    ],
  },
  {
    id: 'gestorias',
    title: 'Gestorías y Asesorías',
    subtitle: 'RGPD, digitalización total y automatización.',
    description: 'Cumplimiento RGPD, e-factura, Verifactu y digitalización completa de procesos. Cero sobresaltos normativos desde la implementación.',
    icon: 'Briefcase',
    challenges: [
      'Pánico a Verifactu y e-factura obligatoria',
      'Documentación dispersa y plantillas manuales',
      'Cualificación manual de consultas nuevas',
      'Seguimiento inconsistente de expedientes',
    ],
    benefits: [
      'Cumplimiento RGPD y e-factura garantizado',
      'Flujos de facturación y firma digital',
      'CRM integrado con cualificación automática',
      'Archivo auditable y documentación centralizada',
    ],
    stats: [
      { value: '0', label: 'Sanciones' },
      { value: '-35%', label: 'Tiempo por trámite' },
      { value: '+45%', label: 'Leads cualificados' },
    ],
  },
  {
    id: 'comercios',
    title: 'Comercios y Retail',
    subtitle: 'Omnicanal, fidelización y más ticket medio.',
    description: 'CRM ligero, catálogo digital, WhatsApp integrado y automatización de seguimiento a clientes. Más ventas cruzadas, más retención.',
    icon: 'Store',
    challenges: [
      'Stock y pedidos desordenados',
      'Respuestas lentas a consultas de clientes',
      'Falta de estrategia de fidelización',
      'Sin visibilidad del rendimiento real',
    ],
    benefits: [
      'CRM + catálogo + WhatsApp integrado',
      'Automatización de seguimiento postventa',
      'Fidelización y ventas cruzadas inteligentes',
      'Dashboards de rendimiento en tiempo real',
    ],
    stats: [
      { value: '+28%', label: 'Ticket medio' },
      { value: '-3h', label: 'Tareas/semana' },
      { value: '+20%', label: 'Retención de clientes' },
    ],
  },
  {
    id: 'autonomos',
    title: 'Autónomos y Freelancers',
    subtitle: 'Estructura para crecer sin caos.',
    description: 'Te damos las herramientas y la estructura que necesitas para gestionar tu negocio como un profesional, sin perder la flexibilidad.',
    icon: 'User',
    challenges: [
      'Gestión de todo en solitario (ventas, admin, producción)',
      'Sin procesos definidos ni automatizaciones',
      'Facturación y cobros manuales',
      'Dificultad para escalar sin contratar',
    ],
    benefits: [
      'Sistema de gestión integral personalizado',
      'Automatización de presupuestos y facturas',
      'CRM simple pero efectivo',
      'Herramientas para escalar sin caos',
    ],
    stats: [
      { value: '-50%', label: 'Tiempo administrativo' },
      { value: '+2x', label: 'Capacidad operativa' },
      { value: '1 panel', label: 'Todo centralizado' },
    ],
  },
  {
    id: 'pymes',
    title: 'PYMEs en Crecimiento',
    subtitle: 'Escalabilidad con procesos claros.',
    description: 'Cuando el negocio crece, los procesos manuales se rompen. Te ayudamos a escalar con sistemas que crecen contigo.',
    icon: 'Building',
    challenges: [
      'Procesos que funcionaban en pequeño pero no escalan',
      'Información dispersa entre departamentos',
      'Falta de indicadores para tomar decisiones',
      'Resistencia al cambio del equipo',
    ],
    benefits: [
      'Procesos escalables y documentados',
      'Sistemas integrados entre departamentos',
      'KPIs y dashboards para dirección',
      'Gestión del cambio y adopción guiada',
    ],
    stats: [
      { value: '+40%', label: 'Productividad' },
      { value: '-60%', label: 'Tiempo en reporting' },
      { value: '100%', label: 'Visibilidad del negocio' },
    ],
  },
];

export const METHOD_STEPS = [
  {
    phase: 1,
    title: 'Escucha y diagnóstico',
    duration: 'Semana 1',
    description: 'Análisis profundo de tu negocio: procesos, datos, herramientas y oportunidades reales. Entregable: informe claro + checklist accionable.',
    deliverables: ['Informe de diagnóstico', 'Mapa de procesos', 'Checklist accionable'],
  },
  {
    phase: 2,
    title: 'Plan de 90 días',
    duration: 'Semana 2',
    description: 'Priorizamos lo que más impacto tiene en ventas, tiempo y cumplimiento. Quick wins desde la primera semana para que veas resultados inmediatos.',
    deliverables: ['Roadmap 30/60/90', 'Quick wins priorizados', 'ROI estimado'],
  },
  {
    phase: 3,
    title: 'Implantación guiada',
    duration: 'Semana 3-6',
    description: 'Implementamos contigo, no para ti. Paso a paso, con soporte real y ajustes en tiempo real. Sin sorpresas ni tecnicismos.',
    deliverables: ['Sistemas configurados', 'Integraciones activas', 'Documentación'],
  },
  {
    phase: 4,
    title: 'Formación y adopción',
    duration: 'Semana 7-8',
    description: 'Tu equipo entiende y usa las herramientas desde el día 1. Sin fricción, sin resistencia al cambio, con resultados desde la primera semana de uso.',
    deliverables: ['Formación personalizada', 'Guías de uso', 'Certificación equipo'],
  },
  {
    phase: 5,
    title: 'KPIs y mejora continua',
    duration: 'Continuo',
    description: 'Medimos, ajustamos y seguimos creciendo juntos. Reportes claros cada mes. Nunca te dejamos solo después de la implementación.',
    deliverables: ['Dashboard KPIs', 'Reportes mensuales', 'Plan de mejora'],
  },
];

export const DIAGNOSTIC_QUESTIONS = [
  {
    id: 1,
    question: '¿Cómo gestionas actualmente la relación con tus clientes?',
    category: 'Gestión de clientes',
    options: [
      { value: '1', label: 'Todo en la cabeza, agenda de papel o mensajes de WhatsApp' },
      { value: '2', label: 'Hojas de cálculo o Excel para llevar el seguimiento' },
      { value: '3', label: 'Un CRM básico, aunque no todos lo usan correctamente' },
      { value: '4', label: 'CRM con automatizaciones: seguimiento, recordatorios y pipeline activo' },
    ],
  },
  {
    id: 2,
    question: '¿Cómo se generan y gestionan tus presupuestos o propuestas?',
    category: 'Procesos comerciales',
    options: [
      { value: '1', label: 'A mano o con plantillas de Word/PDF sin seguimiento' },
      { value: '2', label: 'Plantillas en Excel o Google Docs, pero sin trazabilidad' },
      { value: '3', label: 'Software básico de facturación pero sin conectar con ventas' },
      { value: '4', label: 'Sistema integrado: presupuesto, aprobación, factura y cobro automático' },
    ],
  },
  {
    id: 3,
    question: '¿Cómo atienden a los clientes fuera de tu horario laboral?',
    category: 'Automatización y disponibilidad',
    options: [
      { value: '1', label: 'No hay atención, el cliente espera al día siguiente' },
      { value: '2', label: 'Respuesta automática básica de WhatsApp o email' },
      { value: '3', label: 'Chatbot o formulario web que recoge la consulta' },
      { value: '4', label: 'Agente IA que atiende, cualifica y agenda citas 24/7' },
    ],
  },
  {
    id: 4,
    question: '¿Cuánto tiempo dedica tu equipo semanalmente a tareas repetitivas?',
    category: 'Eficiencia operativa',
    options: [
      { value: '4', label: 'Menos de 5 horas — tenemos todo automatizado' },
      { value: '3', label: 'Entre 5 y 10 horas — algunas tareas siguen siendo manuales' },
      { value: '2', label: 'Entre 10 y 25 horas — hay mucho trabajo administrativo' },
      { value: '1', label: 'Más de 25 horas — el manual ocupa más tiempo que el negocio' },
    ],
  },
  {
    id: 5,
    question: '¿Tienes visibilidad en tiempo real de cómo va tu negocio?',
    category: 'Datos y decisiones',
    options: [
      { value: '1', label: 'No tengo métricas claras, me guío por intuición' },
      { value: '2', label: 'Reviso ventas y gastos mensualmente en el banco o Excel' },
      { value: '3', label: 'Tengo algunos informes pero no están centralizados' },
      { value: '4', label: 'Dashboard en tiempo real: ventas, operaciones y rentabilidad' },
    ],
  },
];

export const NAV_LINKS = [
  { href: '/soluciones', label: 'Soluciones' },
  { href: '/sectores', label: 'Sectores' },
  { href: '/metodo', label: 'Método' },
  { href: '/casos', label: 'Casos' },
  { href: '/recursos', label: 'Blog' },
  { href: '/empresa', label: 'Empresa' },
];

export const FOOTER_LINKS = {
  soluciones: [
    { href: '/soluciones/transformacion-digital', label: 'Transformación Digital' },
    { href: '/soluciones/agentes-ia', label: 'Agentes IA' },
    { href: '/soluciones/desarrollo-web', label: 'Desarrollo Web' },
    { href: '/soluciones/erp-crm', label: 'ERP y CRM' },
    { href: '/soluciones/sistemas-medida', label: 'Sistemas a Medida' },
    { href: '/soluciones/cumplimiento-rgpd', label: 'Cumplimiento RGPD' },
  ],
  sectores: [
    { href: '/sectores/reformas', label: 'Reformas y Construcción' },
    { href: '/sectores/clinicas', label: 'Clínicas y Salud' },
    { href: '/sectores/gestorias', label: 'Gestorías y Asesorías' },
    { href: '/sectores/comercios', label: 'Comercios y Retail' },
    { href: '/sectores/autonomos', label: 'Autónomos' },
    { href: '/sectores/pymes', label: 'PYMEs' },
  ],
  empresa: [
    { href: '/empresa', label: 'Sobre Nosotros' },
    { href: '/metodo', label: 'Nuestro Método' },
    { href: '/casos', label: 'Casos de Éxito' },
    { href: '/contacto', label: 'Contacto' },
  ],
  legal: [
    { href: '/legal/privacidad', label: 'Política de Privacidad' },
    { href: '/legal/cookies', label: 'Política de Cookies' },
    { href: '/legal/aviso-legal', label: 'Aviso Legal' },
  ],
};

export const CASES = [
  {
    id: 1,
    company: 'Clínica dental (Badalona)',
    sector: 'Clínicas y Salud',
    sectorId: 'clinicas',
    challenge: 'Citas perdidas y pocas reseñas. El equipo perdía tiempo llamando a pacientes que no se presentaban.',
    solution: 'Flujo de recordatorios automáticos + encuesta postvista con solicitud de reseña en Google.',
    results: [
      { metric: '-22%', label: 'Absentismo' },
      { metric: '+4.8', label: 'Rating Google' },
      { metric: '12h/sem', label: 'Tiempo ahorrado' },
    ],
    testimonial: 'El sistema de recordatorios ha transformado nuestra agenda. Ya no hay huecos vacíos.',
    author: 'Directora, Clínica Dental',
  },
  {
    id: 2,
    company: 'Empresa de reformas (L\'Hospitalet)',
    sector: 'Reformas y Construcción',
    sectorId: 'reformas',
    challenge: 'Sin visibilidad ni seguimiento de presupuestos. Pérdida de clientes por respuesta lenta.',
    solution: 'MANDO les permitió presupuestar más rápido, hacer seguimiento real de cada obra y cobrar sin retrasos.',
    results: [
      { metric: '+3', label: 'Obras/mes' },
      { metric: '2 clics', label: 'Seguimiento' },
      { metric: '-80%', label: 'Tiempo respuesta' },
    ],
    testimonial: 'Antes perdía clientes por no responder a tiempo. Ahora el sistema trabaja mientras yo estoy en obra.',
    author: 'David T., Reformas',
  },
  {
    id: 3,
    company: 'Gestoría (Gràcia, Barcelona)',
    sector: 'Gestorías y Asesorías',
    sectorId: 'gestorias',
    challenge: 'Pánico a Verifactu y e-factura. Plantillas dispersas y procesos manuales.',
    solution: 'Flujos de facturación, firma digital y archivo auditable. Cumplimiento RGPD completo.',
    results: [
      { metric: '0', label: 'Sanciones' },
      { metric: '-35%', label: 'Tiempo/trámite' },
      { metric: '100%', label: 'Cumplimiento' },
    ],
    testimonial: 'Hoy tenemos un despacho más ágil, moderno y preparado para el futuro. La sensación es de paz y seguridad.',
    author: 'Bufete E&V',
  },
  {
    id: 4,
    company: 'Tienda de barrio (Eixample)',
    sector: 'Comercios y Retail',
    sectorId: 'comercios',
    challenge: 'Stock y pedidos desordenados, respuestas lentas a clientes.',
    solution: 'CRM + catálogo simple + WhatsApp integrado + mini-ERP. Automatización de seguimiento.',
    results: [
      { metric: '+28%', label: 'Ticket medio' },
      { metric: '-3h', label: 'Tareas/semana' },
      { metric: '+20%', label: 'Retención' },
    ],
    testimonial: 'Ahora vendo más, me organizo mejor y siento que mi negocio tiene futuro.',
    author: 'Montse C., Comercio',
  },
];

export const PLANS_DIGITAL = [
  {
    id: 'start',
    name: 'START',
    tagline: 'El primer paso',
    price: '497',
    features: [
      'Diagnóstico digital completo de tu negocio',
      'CRM básico configurado y en funcionamiento',
      '1 automatización implementada',
      'Seguimiento mensual dedicado',
      'Acceso portal de clientes Leapifyes',
    ],
    cta: 'Empezar',
    highlighted: false,
  },
  {
    id: 'essential',
    name: 'ESSENTIAL',
    tagline: 'Las bases sólidas',
    price: '750',
    features: [
      'Todo lo incluido en Start',
      'CRM avanzado + pipeline de ventas',
      '3 automatizaciones activas',
      'Formación del equipo (hasta 5 personas)',
      'Revisión estratégica bimestral',
    ],
    cta: 'Explorar',
    highlighted: false,
  },
  {
    id: 'pro',
    name: 'PRO',
    tagline: 'Crecer con procesos',
    price: '950',
    features: [
      'Todo lo incluido en Essential',
      'Agente IA incluido (llamadas o WhatsApp)',
      'Automatizaciones múltiples sin límite',
      'Embudo comercial completo',
      'Revisión estratégica mensual',
      'Desarrollo web o landing incluido',
    ],
    cta: 'Explorar',
    highlighted: true,
  },
  {
    id: 'premium',
    name: 'PREMIUM 360',
    tagline: 'Transformación completa',
    price: '2.000',
    features: [
      'Estrategia de transformación integral',
      'Todos los servicios activos simultáneamente',
      'Gestión del cambio y adopción',
      'Desarrollo de sistemas a medida',
      'Soporte prioritario (respuesta < 4h)',
      'Roadmap trimestral personalizado',
    ],
    cta: 'Agendar diagnóstico',
    highlighted: false,
  },
];

export const STATS = [
  { value: '50+', label: 'Clientes satisfechos' },
  { value: '60+', label: 'Proyectos completados' },
  { value: '15+', label: 'Años de experiencia' },
  { value: '100%', label: 'Fee/retainer' },
];

// ─────────────────────────────────────────────────────────────
// PRODUCTOS — Fuente única de verdad
// Alimenta a la vez: Navbar (dropdown), Hub (/productos) y Detalle (/productos/:id).
// Solo los productos con `hero` tienen landing interna; el resto son enlaces externos.
// NOTA de marca: AppMando (marketplace del hogar) ≠ MANDO by Leapifyes (ERP de reformas).
// ─────────────────────────────────────────────────────────────
export const PRODUCTS = [
  {
    id: 'appmando',
    name: 'AppMando',
    descriptionMenu: 'Marketplace de servicios del hogar y reformas',
    tagline: 'Servicios del hogar y reformas, en una sola app',
    href: '/productos/appmando',      // landing INTERNA
    external: false,
    status: 'NUEVO',
    statusColor: 'bg-[#2563EB]',
    accentColor: '#2563EB',
    logo: '/appmando/appmando-icon.png',
    appStoreUrl: 'https://apps.apple.com/es/app/id6774574403',
    googlePlay: 'soon',               // botón "Próximamente", sin link
    hero: {
      eyebrow: 'Producto Leapifyes · App nativa en producción',
      title: 'AppMando',
      subtitle: 'El marketplace que conecta a particulares con profesionales verificados de reformas y servicios del hogar en toda España. El cliente encuentra al profesional ideal en pocos clics; el profesional recibe cada día clientes que ya están buscando lo que ofrece. Sin comisiones por trabajo cerrado.',
    },
    gallery: [
      { src: '/appmando/captura-confianza.webp', alt: 'Encuentra profesionales de confianza en minutos' },
      { src: '/appmando/captura-presupuestos.webp', alt: 'Solicita presupuestos gratis' },
      { src: '/appmando/captura-perfiles.webp', alt: 'Compara perfiles verificados' },
      { src: '/appmando/captura-chat.webp', alt: 'Habla directamente con el profesional' },
      { src: '/appmando/captura-hogar.webp', alt: 'Todo lo que necesitas para tu hogar' },
    ],
    features: [
      { title: 'Conexión bidireccional', description: 'Clientes y profesionales se encuentran en tiempo real dentro de la misma plataforma.' },
      { title: 'Cobertura nacional', description: 'Disponible en toda España desde el primer día, no solo en grandes ciudades.' },
      { title: 'Profesionales de confianza', description: 'Perfiles, reseñas y verificación para contratar con seguridad.' },
      { title: 'Sin comisiones', description: 'El profesional no paga comisión por trabajo cerrado. Modelo de suscripción transparente.' },
      { title: 'Gestión integrada', description: 'Solicitudes, mensajería y seguimiento, todo dentro de la app.' },
      { title: 'App nativa', description: 'Experiencia móvil completa en App Store. Google Play, próximamente.' },
    ],
    process: [
      { step: '01', title: 'Publica o busca', description: 'El cliente describe lo que necesita; el profesional configura su perfil y servicios.' },
      { step: '02', title: 'Conecta', description: 'AppMando pone en contacto a ambos lados según servicio y ubicación.' },
      { step: '03', title: 'Acuerda y trabaja', description: 'Cliente y profesional hablan directo, acuerdan y cierran. Sin intermediarios.' },
    ],
    benefits: [
      'Para clientes: encuentra al profesional adecuado en minutos, compara y contacta directo. Gratis.',
      'Para profesionales: recibe clientes que ya te buscan, sin pujar por leads ni pagar comisión por cierre.',
      'Plataforma de confianza: reseñas reales y perfiles verificados a ambos lados.',
      'Tecnología propia de Leapifyes: diseñada, construida y operada en casa.',
    ],
    stats: [
      { value: '0%', label: 'Comisión por trabajo' },
      { value: 'Toda España', label: 'Cobertura nacional' },
      { value: 'Gratis', label: 'Para clientes' },
      { value: 'App Store', label: 'Disponible en iOS' },
    ],
  },

  // --- Migrados desde Navbar (enlaces externos, sin landing interna) ---
  { id: 'agente-ia', name: 'Agente IA para Pymes', descriptionMenu: 'IA conversacional 24/7 lista para usar', href: 'https://ia.leapifyes.com', external: true, status: 'NUEVO', statusColor: 'bg-[#D946EF]', logo: ASSETS.logoIA },
  { id: 'mando-erp', name: 'MANDO by Leapifyes', descriptionMenu: 'ERP de gestión para empresas de reformas y construcción', href: 'https://mando.leapifyes.com', external: true, status: 'LIVE', statusColor: 'bg-[#1B93A4]', logo: ASSETS.logoMando },
  { id: 'trebol', name: 'TRÉBOL Finance', descriptionMenu: 'Fintech personal con IA', href: 'https://trebolfinance.leapifyes.com/login', external: true, status: 'BETA', statusColor: 'bg-[#10b981]', logo: ASSETS.logoTrebol },
];
